var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"container"},[_c('input',_vm._g(_vm._b({attrs:{"type":"checkbox"}},'input',_vm.$attrs,false),_vm.$listeners)),_c('div',{staticClass:"checkmark"}),_c('div',{staticClass:"elem-inj"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }